var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEcoLeaf = function SvgEcoLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EcoLeaf_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M2 2h16v16H2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "EcoLeaf_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    fillOpacity: 0,
    rx: 2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#24961B",
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EcoLeaf_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EcoLeaf_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.5 16c-.37 0-.74-.05-1.11-.13s-.76-.2-1.14-.36c.13-1.34.52-2.6 1.16-3.76.65-1.17 1.47-2.2 2.49-3.09-1.23.62-2.29 1.45-3.18 2.47a8.8 8.8 0 0 0-1.88 3.5c-.04-.04-.08-.07-.12-.11l-.13-.13c-.52-.52-.91-1.1-1.19-1.75-.27-.64-.4-1.31-.4-2.01 0-.76.15-1.48.45-2.17s.71-1.3 1.25-1.83c.89-.9 2.06-1.49 3.5-1.76 1.43-.27 3.44-.3 6.03-.08.2 2.66.17 4.69-.1 6.08s-.85 2.54-1.73 3.42q-.825.825-1.83 1.26-1.005.45-2.07.45"
  })))));
};
export default SvgEcoLeaf;